import React from 'react';

import { AvailabilityPageBase } from './AvailabilityPageBase';
import { AvailabilityList } from './components/AvailabilityList';

export function AvailabilityPage() {
	return <AvailabilityPageBase ListComponent={AvailabilityList} />;
}
